import { render, staticRenderFns } from "./spread.vue?vue&type=template&id=027acfd7&scoped=true"
import script from "./spread.vue?vue&type=script&lang=js"
export * from "./spread.vue?vue&type=script&lang=js"
import style0 from "./spread.vue?vue&type=style&index=0&id=027acfd7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027acfd7",
  null
  
)

export default component.exports